import { METERS_PER_KILOMETER, METERS_PER_MILE } from "src/app/constants/distance-constants";
import { LocaleService } from "src/app/services/locale/locale.service";

/**
 * Format a distance given in meters using the locale's unit system.
 *
 * The API sends this value as a plain scalar in meters (unlike inspection details, which arrive as
 * a value/unit conversion pair), so the unit is chosen here rather than picked out of the response.
 *
 * @param meters Distance in meters
 * @param localeService Locale Service
 * @returns The distance with its unit appended, for example '1.0km' or '1.0mi'
 */
export const formatDistance = (meters: number | string, localeService: LocaleService): string =>
	localeService.usesMetricSystem()
		? `${(Number(meters) / METERS_PER_KILOMETER).toFixed(1)}km`
		: `${(Number(meters) / METERS_PER_MILE).toFixed(1)}mi`;
